/* eslint-disable react/forbid-prop-types */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import AppTextInput from '../../../../shared/components/app-text-input/AppTextInput';
import PackageTransactionCard from './PackageTransactionCard';
import {
  TRANSACTION_TABS,
  matchesTransaction,
  sortTransactions,
  transactionGroup,
} from './packageTransactionUtils';
import './PackageTransactionsList.scss';

/**
 * Package bookings and enquiries for My Bookings: search, status tabs with
 * counts, newest first. Same chrome as the eSIM / visa lists.
 */
function PackageTransactionsList({ transactions }) {
  const [searchText, setSearchText] = useState('');
  const [tab, setTab] = useState('all');

  const matching = useMemo(
    () =>
      sortTransactions(
        transactions.filter(
          (t) => t?.pkgBookingId && matchesTransaction(t, searchText),
        ),
      ),
    [transactions, searchText],
  );

  const counts = useMemo(() => {
    const c = { all: matching.length };
    matching.forEach((t) => {
      const g = transactionGroup(t);
      c[g] = (c[g] || 0) + 1;
    });
    return c;
  }, [matching]);

  const shown =
    tab === 'all'
      ? matching
      : matching.filter((t) => transactionGroup(t) === tab);

  return (
    <section className="flight-booking-list-page pkg-tx-list">
      <div className="train-search-container">
        <div className="mb-2 d-flex justify-content-end">
          <div className="pkg-tx-list__search">
            <AppTextInput
              value={searchText}
              label="Search booking ID, package or traveller"
              onChange={(e) => setSearchText(e.target.value.slice(0, 60))}
            />
          </div>
        </div>
      </div>
      <div className="d-flex gap-2 flex-wrap flight-booking-list-page_transactions-type-container">
        {TRANSACTION_TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            aria-pressed={tab === t.key}
            className={`pkg-tx-list__tab ${
              tab === t.key ? 'pkg-tx-list__tab--active' : ''
            }`}
          >
            {t.label} ({counts[t.key] || 0})
          </button>
        ))}
      </div>
      {shown.length > 0 ? (
        <div className="hotel-bookings-list_container">
          {shown.map((booking) => (
            <PackageTransactionCard
              key={booking.pkgBookingId}
              booking={booking}
            />
          ))}
        </div>
      ) : (
        <div className="p-3 text-center fw-500">
          <span>
            {searchText ? 'No bookings match your search' : 'No Bookings'}
          </span>
        </div>
      )}
    </section>
  );
}

PackageTransactionsList.propTypes = {
  transactions: PropTypes.array.isRequired,
};

export default PackageTransactionsList;
